export const csvValue = (value: string | number | null | undefined): string => {
  if (value == null) return ''

  const text = String(value)

  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export const toCsv = (header: string[], rows: (string | number | null | undefined)[][]): string =>
  [header, ...rows].map((row) => row.map(csvValue).join(',')).join('\n')

export const downloadCsv = (csv: string, fileName: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  link.click()

  URL.revokeObjectURL(url)
}
